type HomePromotion = {
  title: string;
  description: string;
  href: string;
  enabled: boolean;
};

// 壳占位文案；真实图片由客户端按 homepageConfig.promotions 写入，避免先打本地 home-tiles。
function promotionsFor(gameKey: string): HomePromotion[] {
  const base = `/${gameKey}`;
  return [
    {
      title: '新手补给指南',
      description: '入门资源速查',
      href: `${base}/guide?title=新手资源分配指南&type=新手攻略`,
      enabled: true,
    },
    {
      title: '本期阵容推荐',
      description: '查看热门搭配',
      href: `${base}/guide?title=黄金竞技场配队&type=竞技场攻略`,
      enabled: true,
    },
  ];
}

function escapeHtml(value: string) {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

export function renderHomePromotionSlots(gameKey: string) {
  const visiblePromotions = promotionsFor(gameKey).filter(
    (promotion) => promotion.enabled,
  );
  if (!visiblePromotions.length) return '';

  return `<nav class="home-promotion-slots" aria-label="推荐活动">${visiblePromotions
    .slice(0, 2)
    .map(
      (promotion) => `<a href="${escapeHtml(promotion.href)}" class="home-promotion-card">
        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="" width="128" height="72" data-home-tile-pending="1">
        <span><strong>${escapeHtml(promotion.title)}</strong><small>${escapeHtml(promotion.description)}</small></span>
      </a>`,
    )
    .join('')}</nav>`;
}
